import React from "react"

export type NoteContentProps = {
  children: React.ReactNode
}

export function NoteContent({ children }: NoteContentProps) {
  return (
    <div
      className="[grid-area:content] flex flex-col gap-1"
      data-slot="note-content"
    >
      {children}
    </div>
  )
}
